<template>
  <section class="free-division">
    <VideoMode :freeInfo="freeInfo" @toPage="toPage"></VideoMode>
    <div class="free-division-item" v-for="(item, index) in data">
      <FreeItem :data="item"></FreeItem>
    </div>
  </section>
</template>

<script>
import keys from 'lodash.keys'
import module from '../modules/free-division'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'

import VideoMode from '../components/Free/VideoMode'
import FreeItem from '../components/Free/FreeItem'

export default {
  computed: {
    ...mapState(module.name, keys(module.state)),
    ...mapGetters(module.name, keys(module.getters))
  },
  methods: {
    ...mapMutations(module.name, keys(module.mutations)),
    ...mapActions(module.name, keys(module.actions)),
    toPage () {
      this.$router.push(`/free_video/main/${this.freeInfo.id}`)
    }
  },
  beforeCreate () {
    this.$store.registerModule(module.name, module)
  },
  created () {
    this.init()
  },
  beforeDestroy () {
    this.$store.unregisterModule(module.name)
  },
  components: {
    VideoMode,
    FreeItem
  }
}
</script>

<style lang="scss">
@charset "UTF-8";
@import "../style/main";

.free-division {
  padding: rem(37) rem(30) rem(128);
}
</style>
